import { MotionGenerationPage } from '../components/ProductPages';
import { publicMeta } from './public-meta';

export const meta = publicMeta(
  'Performance Generation | Cartwheel',
  'Performance Generation uses Swing to create human motion from text prompts, with batch generation and pipeline-ready results.',
);

export default MotionGenerationPage;
